// File: src/pages/admin/Admin.js
import React from 'react'
import { Tabs, Tab, TabList, TabPanel } from '../../components/TabsAll/Tabs/Tabs';
import { CgProfile } from "react-icons/cg";
import Dashboard from '../../components/TabsAll/Admin/Dashboad/Dashboard';
import Shareholders from '../../components/TabsAll/Admin/Shareholders/Shareholders';
import Approvals from '../../components/TabsAll/Admin/Approvals/Approvals';
import DealFlow from '../../components/TabsAll/Admin/DealFlow/DealFlow';
import InvestorCRM from '../../components/TabsAll/Admin/InvestorCRM/InvestorCRM';
import Securities from '../../components/TabsAll/Admin/Securities/Securities';
import { Link } from 'react-router-dom';


function Admin() {
  
  return (
    <Tabs>
      <TabList>
        <Tab index={0}>Dashboard</Tab>
        <Tab index={1}>Securities</Tab> 
        <Tab index={2}>Shareholders</Tab> 
        <Tab index={3}>Approvals</Tab>
        <Tab index={4}>Deal Flow</Tab>
        <Tab index={5}>Investor CRM</Tab>
        <Tab index={6}><Link to="/account" style={{ textDecoration: 'none', color: 'inherit' }}> <CgProfile size={14} /></Link>
        </Tab>

      </TabList>

      <TabPanel index={0}><Dashboard /></TabPanel>
      <TabPanel index={1}><Securities/></TabPanel>
      <TabPanel index={2}><Shareholders/></TabPanel>
      <TabPanel index={3}><Approvals /></TabPanel>
      <TabPanel index={4}><DealFlow /></TabPanel>
      <TabPanel index={5}><InvestorCRM /></TabPanel>
    </Tabs>
  );
}

export default Admin;
